// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  BankOutlined,
  HddOutlined,
  BarChartOutlined,
  RadarChartOutlined,
  ContainerOutlined,
  EnvironmentOutlined,
  FileImageOutlined,
  FolderViewOutlined,
  FundProjectionScreenOutlined,
  IdcardOutlined,
  HeatMapOutlined,
  AreaChartOutlined,
  LayoutOutlined,
  ProfileOutlined,
  DatabaseOutlined,
  EnvironmentFilled,
  EditFilled,
  RedEnvelopeFilled,
  RobotFilled,
  CrownFilled,
  ProfileFilled,
  GithubFilled,
  SlackSquareFilled,
  NotificationFilled,
  HomeFilled,
  SwitcherFilled,
  ExperimentFilled,
  DribbbleCircleFilled,
  FolderOpenFilled,
  ReconciliationFilled,
  CodeSandboxSquareFilled,
  SisternodeOutlined,
  CarFilled,
  QqCircleFilled,
  UserSwitchOutlined,
  ShopFilled,
  ScheduleOutlined,
  ShopOutlined,
  NodeCollapseOutlined,
  FundOutlined,
  QrcodeOutlined,
  //BoxPlotFilled,
} from '@ant-design/icons';
import { requestedFeaturesAll, requestedMenuAll } from '../routes/constants/menuAccess';
// import { approvalsMenus } from './constants/constants';

// import VerifyMenuAccess from '../../common/components/verify-access/verify-menu-access';

// icons
const icons = {
  BankOutlined,
  HddOutlined,
  DatabaseOutlined,
  HomeFilled,
  EditFilled,
  FolderOpenFilled,
  ReconciliationFilled,
  CrownFilled,
  NotificationFilled,
  RedEnvelopeFilled,
  ShopFilled,
  DribbbleCircleFilled,
  GithubFilled,
  ProfileFilled,
  RobotFilled,
  QqCircleFilled,
  ExperimentFilled,
  CodeSandboxSquareFilled,
  SlackSquareFilled,
  SwitcherFilled,
  BarChartOutlined,
  RadarChartOutlined,
  HeatMapOutlined,
  AreaChartOutlined,
  ContainerOutlined,
  EnvironmentOutlined,
  UserSwitchOutlined,
  SisternodeOutlined,
  ScheduleOutlined,
  CarFilled,
  EnvironmentFilled,
  FileImageOutlined,
  FolderViewOutlined,
  FundProjectionScreenOutlined,
  IdcardOutlined,
  LayoutOutlined,
  ProfileOutlined,
  ShopOutlined,
  NodeCollapseOutlined,
  FundOutlined,
  QrcodeOutlined
};

const {
  dashboardKey,
  appTrackReportKey,
  companyMasterKey,
  glMasterKey,
  planValidationKey,
  approvalClaimBOKey,
  regularApprovalClaimRMKey,
  regularApprovalClaimDMKey,
  regularApprovalClaimHRKey,
  regularApprovalClaimAEKey,
  regularApprovalClaimAMKey,
  bankMasterKey,
  claimMasterKey,
  ifdCompetitorMasterKey,
  fdCompetitorMasterKey,
  competitorOffersKey,
  customerMasterKey,
  divisionMasterKey,
  dropdownMasterKey,
  locationMasterKey,
  menuMasterKey,
  outletMasterKey,
  planApplicableMasterKey,
  planCreationKey,
  claimCreationKey,
  plantMasterKey,
  productMasterKey,
  prospectMasterKey,
  prospectValidationMasterKey,
  roleMasterKey,
  shiftMasterKey,
  userMasterKey,
  attendanceReportKey,
  userReportKey,
  venueMasterKey,
  zoneMasterKey,
  travelReportKey,
  ifoodsPlanReportKey,
  outletVisitReportKey,
  prospectReportKey,
  primeCustReportKey,
  competitorReportKey,
  secondCustReportKey,
  planDeviationBOKey,
  // approvalFoodsMasterKey,
  secondaryOrderReportKey,
  primaryCustomerVisitReportKey,
  secondaryOutletVisitReportKey,
  mapViewReportKey,
  planDeviationReportKey,
  claimDetailsReportKey,
  claimExpenseReportKey,
  travelClaimReportKey,
  pjpReportKey,
  primaryOrderReportKey,
  venueMappingReportKey,
  marketPromotionReportKey,
  settingsKey,
  commonNotificationKey,
  calendarEventKey,
  primeMatMappingKey,
  planValidationManagerKey,
  activeUsersDashboardKey,
  ifoodsDashboardKey,
  eventMasterKey,
  planDeviationManagerKey,
  approvalClaimExecKey,
  approvalClaimManagerKey,
  claimFrequencyTypeKey,
  claimFrequencyMasterKey,
  approvalSecCustomerKey,
  claimLocationCategoryKey,
  schemesCategoryKey,
  targetKey,
  claimStatusLogKey,
  claimLogKey,
  claimExpenseLogKey,
  dashboardSliderKey,
  claimApprovalLevelControlKey,

  //Sooji QR Bag //

  bagRequestKey,
  bagIssueKey,
  storeNewBagRequestKey,
  bagReportKey,
  fillBagKey,
  qcReleaseKey,
  qcReleaseExceededKey,
  roastingProcessKey,
  roastingProcessExceededKey,
  fumigationProcessKey,
  fumigationProcessExceededKey,
  qrTransReportKey,
  newBagRequestKey,
  qrcodedBagStatusKey,

  /* Foods Scheme*/
  schemeOperationsKey,
  schemeCreationKey,
  schemeCreationApprovalKey,
  schemeCreationApprovalCHKey,
  schemeCreationApprovalBHKey,
  schemeStatusMasterKey,
  schemeNonEligibleApprovalMasterKey,
  schemeGMApprovalKey,
  schemeCHapprovalKey,
  schemeAdminEditKey,
  schemeBHapprovalKey,
  schemeAHcreditnoteApprovalKey,
  schemeCreditnoteReportKey,
  schemeCostCenterMasterKey,
  schemeProductCostCenterMappingKey,
  schemeCustomerWiseReportKey,
  schemeCostCenterActualReportKey,
  schemeRejectedCustomerReportKey,
  pestControlKey,
  pestControlDailyEntryKey,
  pestControlReportKey,
  rodentBoxLocationMasterKey,
  locationTrapStationMappingKey,
  rodentQRCodeMappingKey,
  rodentQRCodeKey,
} = requestedMenuAll;
const { readKey } = requestedFeaturesAll;

const PestControl = [
  pestControlDailyEntryKey,
  pestControlReportKey,
  rodentBoxLocationMasterKey,
  locationTrapStationMappingKey,
  rodentQRCodeMappingKey,
  rodentQRCodeKey
];

const Scheme = [schemeCreationKey, schemeCreationApprovalKey,
  schemeCreationApprovalCHKey, schemeCreationApprovalBHKey, schemeGMApprovalKey,
  schemeStatusMasterKey, schemeNonEligibleApprovalMasterKey, schemeCHapprovalKey,
  schemeAdminEditKey,
  schemeBHapprovalKey, schemeAHcreditnoteApprovalKey, schemeCreditnoteReportKey, schemeCustomerWiseReportKey, schemeCostCenterActualReportKey, schemeRejectedCustomerReportKey]

const Dashboard = [dashboardKey];
const AnalyticsDashboard = [activeUsersDashboardKey, ifoodsDashboardKey];
const Masters = [
  companyMasterKey,
  bankMasterKey,
  claimMasterKey,
  ifdCompetitorMasterKey,
  competitorOffersKey,
  fdCompetitorMasterKey,
  schemesCategoryKey,
  customerMasterKey,
  divisionMasterKey,
  dropdownMasterKey,
  locationMasterKey,
  menuMasterKey,
  outletMasterKey,
  planApplicableMasterKey,
  plantMasterKey,
  productMasterKey,
  prospectMasterKey,
  roleMasterKey,
  shiftMasterKey,
  userMasterKey,
  venueMasterKey,
  zoneMasterKey,
  glMasterKey,
  settingsKey,
  primeMatMappingKey,
  eventMasterKey,
  claimFrequencyMasterKey,
  claimFrequencyTypeKey,
  claimLocationCategoryKey,
  claimApprovalLevelControlKey,
  schemeCostCenterMasterKey,
  schemeProductCostCenterMappingKey,
];
//const approvalsGroup = [approvalFoodsMasterKey];
const Creation = [planCreationKey, claimCreationKey, calendarEventKey, targetKey];
const Validation = [
  prospectValidationMasterKey,
  planValidationKey,
  planDeviationBOKey,
  approvalClaimBOKey,
  commonNotificationKey,
  planValidationManagerKey,
  planDeviationManagerKey,
  approvalClaimExecKey,
  approvalClaimManagerKey,
  regularApprovalClaimRMKey,
  regularApprovalClaimAMKey,
  regularApprovalClaimDMKey,
  regularApprovalClaimHRKey,
  regularApprovalClaimAEKey,
  approvalSecCustomerKey
];
const Reports = [
  attendanceReportKey,
  userReportKey,
  travelReportKey,
  ifoodsPlanReportKey,
  outletVisitReportKey,
  prospectReportKey,
  primeCustReportKey,
  competitorReportKey,
  secondCustReportKey,
  appTrackReportKey,
  mapViewReportKey,
  claimDetailsReportKey,
  claimExpenseReportKey,
  travelClaimReportKey,
  secondaryOutletVisitReportKey,
  secondaryOrderReportKey,
  primaryCustomerVisitReportKey,
  pjpReportKey,
  primaryOrderReportKey,
  venueMappingReportKey,
  marketPromotionReportKey,
  claimStatusLogKey,
  claimLogKey,
  claimExpenseLogKey,
  dashboardSliderKey,
];

//Sooji QR Bag //

const Production = [
  bagRequestKey,
  bagIssueKey,
  storeNewBagRequestKey,
  bagReportKey,
  fillBagKey,
  qcReleaseKey,
  qcReleaseExceededKey,
  roastingProcessKey,
  fumigationProcessKey,
  qrTransReportKey,
  newBagRequestKey,
  qrcodedBagStatusKey
];
// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages = {
  id: 'group-pages',
  type: 'group',
  children: [
    ...(Dashboard.length >= 1
      ? [
        {
          icon: icons.BankOutlined,
          id: 'dashboard',
          title: <FormattedMessage id="dashboard" />,
          type: 'item',
          url: '/dashboard',
          target: false,
          requestedMenu: dashboardKey,
          requestedFeature: readKey
        }
      ]
      : []),
    ...(AnalyticsDashboard.length >= 1
      ? [
        {
          id: 'analytics-dashboard',
          title: <FormattedMessage id="analytics-dashboard" />,
          type: 'collapse',
          icon: icons.EditFilled,
          allMenus: AnalyticsDashboard,
          children: [
            {
              id: 'active-users-dashboard',
              title: <FormattedMessage id="active-users-dashboard" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/active-users',
              target: false,
              requestedMenu: activeUsersDashboardKey,
              requestedFeature: readKey
            },
            {
              id: 'ifoods-dashboard',
              title: <FormattedMessage id="ifoods-dashboard" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/ifoods-dashboard',
              target: false,
              requestedMenu: ifoodsDashboardKey,
              requestedFeature: readKey
            }
          ]
        }
      ]
      : []),
    ...(Masters.length >= 1
      ? [
        {
          id: 'masters',
          title: <FormattedMessage id="masters" />,
          type: 'collapse',
          // url: '/',
          icon: icons.DatabaseOutlined,
          allMenus: Masters,
          children: [
            {
              id: 'bank-master',
              title: <FormattedMessage id="bank-master" />,
              type: 'item',
              icon: icons.BankOutlined,
              url: '/bank-master',
              target: false,
              requestedMenu: bankMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'company-master',
              title: <FormattedMessage id="company-master" />,
              type: 'item',
              icon: icons.ShopOutlined,
              url: '/company-master',
              target: false,
              requestedMenu: companyMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-location-category',
              title: <FormattedMessage id="claim-location-category" />,
              type: 'item',
              icon: icons.NodeCollapseOutlined,
              url: '/claim-location-category',
              target: false,
              requestedMenu: claimLocationCategoryKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-frequency-type',
              title: <FormattedMessage id="claim-frequency-type" />,
              type: 'item',
              icon: icons.LayoutOutlined,
              url: '/claim-frequency-type',
              target: false,
              requestedMenu: claimFrequencyTypeKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-frequency-master',
              title: <FormattedMessage id="claim-frequency-master" />,
              type: 'item',
              icon: icons.HddOutlined,
              url: '/claim-frequency-master',
              target: false,
              requestedMenu: claimFrequencyMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-approval-level-control',
              title: <FormattedMessage id="claim-approval-level-control" />,
              type: 'item',
              icon: icons.HddOutlined,
              url: '/claim-approval-level-control',
              target: false,
              requestedMenu: claimApprovalLevelControlKey,
              requestedFeature: readKey
            },
            {
              id: 'competitor-offers',
              title: <FormattedMessage id="competitor-offers" />,
              type: 'item',
              icon: icons.NotificationFilled,
              url: '/competitor-offers',
              target: false,
              requestedMenu: competitorOffersKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-master',
              title: <FormattedMessage id="claim-master" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/claim-master',
              target: false,
              requestedMenu: claimMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'customer-master',
              title: <FormattedMessage id="customer-master" />,
              type: 'item',
              icon: icons.ProfileFilled,
              url: '/customer-master',
              target: false,
              requestedMenu: customerMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'dashboard-slider',
              title: <FormattedMessage id="dashboard-slider" />,
              type: 'item',
              icon: icons.FundOutlined,
              url: '/dashboard-slider',
              target: false,
              requestedMenu: dashboardSliderKey,
              requestedFeature: readKey
            },
            {
              id: 'division-master',
              title: <FormattedMessage id="division-master" />,
              type: 'item',
              icon: icons.ScheduleOutlined,
              url: '/division-master',
              target: false,
              requestedMenu: divisionMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'dropdown-master',
              title: <FormattedMessage id="dropdown-master" />,
              type: 'item',
              icon: icons.SwitcherFilled,
              url: '/dropdown-master',
              target: false,
              requestedMenu: dropdownMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'event-master',
              title: <FormattedMessage id="event-master" />,
              type: 'item',
              url: '/event-master',
              icon: icons.SwitcherFilled,
              target: false,
              requestedMenu: eventMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'fd-competitor-master',
              title: <FormattedMessage id="fd-competitor-master" />,
              type: 'item',
              icon: icons.CrownFilled,
              url: '/fd-competitor-master',
              target: false,
              requestedMenu: fdCompetitorMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'gl-master',
              title: <FormattedMessage id="gl-master" />,
              type: 'item',
              icon: icons.NotificationFilled,
              url: '/gl-master',
              target: false,
              requestedMenu: glMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'ifd-competitor-master',
              title: <FormattedMessage id="ifd-competitor-master" />,
              type: 'item',
              icon: icons.CrownFilled,
              url: '/ifd-competitor-master',
              target: false,
              requestedMenu: ifdCompetitorMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'location-master',
              title: <FormattedMessage id="location-master" />,
              type: 'item',
              icon: icons.EnvironmentFilled,
              url: '/location-master',
              target: false,
              requestedMenu: locationMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'menu-master',
              title: <FormattedMessage id="menu-master" />,
              type: 'item',
              icon: icons.SwitcherFilled,
              url: '/menu-master',
              target: false,
              requestedMenu: menuMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'outlet-master',
              title: <FormattedMessage id="outlet-master" />,
              icon: icons.HomeFilled,
              type: 'item',
              url: '/outlet-master',
              target: false,
              requestedMenu: outletMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'plant-master',
              title: <FormattedMessage id="plant-master" />,
              type: 'item',
              icon: icons.ExperimentFilled,
              url: '/plant-master',
              target: false,
              requestedMenu: plantMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-applicable',
              title: <FormattedMessage id="plan-applicable" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/plan-applicable',
              target: false,
              requestedMenu: planApplicableMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'product-master',
              title: <FormattedMessage id="product-master" />,
              type: 'item',
              icon: icons.CodeSandboxSquareFilled,
              url: '/product-master',
              target: false,
              requestedMenu: productMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'prospect-master',
              title: <FormattedMessage id="prospect-master" />,
              type: 'item',
              icon: icons.DribbbleCircleFilled,
              url: '/prospect-master',
              target: false,
              requestedMenu: prospectMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'primary-material-mapping',
              title: <FormattedMessage id="primary-material-mapping" />,
              type: 'item',
              icon: icons.SlackSquareFilled,
              url: '/primary-material-mapping',
              target: false,
              requestedMenu: primeMatMappingKey,
              requestedFeature: readKey
            },
            {
              id: 'role-master',
              title: <FormattedMessage id="role-master" />,
              type: 'item',
              icon: icons.RobotFilled,
              url: '/role-master',
              target: false,
              requestedMenu: roleMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'settings',
              title: <FormattedMessage id="settings" />,
              type: 'item',
              icon: icons.SlackSquareFilled,
              url: '/settings',
              target: false,
              requestedMenu: settingsKey,
              requestedFeature: readKey
            },
            {
              id: 'shift-master',
              title: <FormattedMessage id="shift-master" />,
              type: 'item',
              icon: icons.QqCircleFilled,
              url: '/shift-master',
              target: false,
              requestedMenu: shiftMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'schemes-category',
              title: <FormattedMessage id="schemes-category" />,
              type: 'item',
              icon: icons.ScheduleOutlined,
              url: '/schemes-category',
              target: false,
              requestedMenu: schemesCategoryKey,
              requestedFeature: readKey
            },
            {
              id: 'user-master',
              title: <FormattedMessage id="user-master" />,
              type: 'item',
              icon: icons.UserSwitchOutlined,
              url: '/user-master',
              target: false,
              requestedMenu: userMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'venue-master',
              title: <FormattedMessage id="venue-master" />,
              type: 'item',
              icon: icons.ShopFilled,
              url: '/venue-master',
              target: false,
              requestedMenu: venueMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'zone-master',
              title: <FormattedMessage id="zone-master" />,
              type: 'item',
              icon: icons.SlackSquareFilled,
              url: '/zone-master',
              target: false,
              requestedMenu: zoneMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'scheme-cost-center-master',
              title: <FormattedMessage id="scheme-cost-center-master" />,
              type: 'item',
              icon: icons.DatabaseOutlined,
              url: '/scheme-cost-center-master',
              target: false,
              requestedMenu: schemeCostCenterMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'scheme-product-cost-center-mapping',
              title: <FormattedMessage id="scheme-product-cost-center-mapping" />,
              type: 'item',
              icon: icons.DatabaseOutlined,
              url: '/scheme-product-cost-center-mapping',
              target: false,
              requestedMenu: schemeProductCostCenterMappingKey,
              requestedFeature: readKey
            }
          ]
        }
      ]
      : []),
    // {
    //   id: approvalsMenus,
    //   title: <FormattedMessage id="approval" />,
    //   type: 'collapse',
    //   // url: '/',
    //   icon: icons.ScheduleOutlined,
    //   allMenus: approvalsGroup,
    //   children: [
    //     {
    //       id: 'approval-foods',
    //       title: <FormattedMessage id="foods-plan-approval" />,
    //       type: 'item',
    //       icon:icons.ScheduleOutlined,
    //       url: '/approval-foods',
    //       target: false,
    //       requestedMenu: approvalFoodsMasterKey,
    //       requestedFeature: readKey
    //     },

    //   ]
    // },
    ...(Creation.length >= 1
      ? [
        {
          id: 'creation',
          title: <FormattedMessage id="creation" />,
          type: 'collapse',
          // url: '/',
          icon: icons.EditFilled,
          allMenus: Creation,
          children: [
            {
              id: 'pjp-creation',
              title: <FormattedMessage id="pjp-creation" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/pjp-creation',
              target: false,
              requestedMenu: planCreationKey,
              requestedFeature: readKey
            },
            {
              id: 'calendar-event',
              title: <FormattedMessage id="calendar-event" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/calendar-event',
              target: false,
              requestedMenu: calendarEventKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-creation',
              title: <FormattedMessage id="claim-creation" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/claim-creation',
              target: false,
              requestedMenu: claimCreationKey,
              requestedFeature: readKey
            },
            {
              id: 'target',
              title: <FormattedMessage id="target" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/target',
              target: false,
              requestedMenu: targetKey,
              requestedFeature: readKey
            }
          ]
        }
      ]
      : []),
    ...(Validation.length >= 1
      ? [
        {
          id: 'validation',
          title: <FormattedMessage id="validation" />,
          type: 'collapse',
          // url: '/',
          icon: icons.ReconciliationFilled,
          allMenus: Validation,
          children: [
            {
              id: 'plan-validation',
              title: <FormattedMessage id="plan-validation" />,
              type: 'item',
              icon: icons.ScheduleOutlined,
              url: '/plan-validation',
              target: false,
              requestedMenu: planValidationKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-validation-manager',
              title: <FormattedMessage id="plan-validation-manager" />,
              type: 'item',
              icon: icons.ScheduleOutlined,
              url: '/plan-validation-manager',
              target: false,
              requestedMenu: planValidationManagerKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-deviation-approval-backoffice',
              title: <FormattedMessage id="plan-deviation-validation-backoffice" />,
              type: 'item',
              icon: icons.ScheduleOutlined,
              url: '/plan-deviation-approval-backoffice',
              target: false,
              requestedMenu: planDeviationBOKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-deviation-approval-manager',
              title: <FormattedMessage id="plan-deviation-validation-manager" />,
              type: 'item',
              icon: icons.ScheduleOutlined,
              url: '/plan-deviation-approval-manager',
              target: false,
              requestedMenu: planDeviationManagerKey,
              requestedFeature: readKey
            },
            {
              id: 'prospect-validation',
              title: <FormattedMessage id="ifoods-prospect-validation" />,
              type: 'item',
              icon: icons.DribbbleCircleFilled,
              url: '/prospect-validation',
              target: false,
              requestedMenu: prospectValidationMasterKey,
              requestedFeature: readKey
            },
            {
              id: 'approval-secondary-customer',
              title: <FormattedMessage id="approval-secondary-customer" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/approval-secondary-customer',
              target: false,
              requestedMenu: approvalSecCustomerKey,
              requestedFeature: readKey
            },
            {
              id: 'approval-claim-backoffice',
              title: <FormattedMessage id="claim-approval-backoffice" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/approval-claim-backoffice',
              target: false,
              requestedMenu: approvalClaimBOKey,
              requestedFeature: readKey
            },
            {
              id: 'approval-claim-executive',
              title: <FormattedMessage id="claim-approval-executive" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/approval-claim-executive',
              target: false,
              requestedMenu: approvalClaimExecKey,
              requestedFeature: readKey
            },
            {
              id: 'approval-claim-manager',
              title: <FormattedMessage id="claim-approval-manager" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/approval-claim-manager',
              target: false,
              requestedMenu: approvalClaimManagerKey,
              requestedFeature: readKey
            },
            {
              id: 'regular-approval-claim-reporting-manager',
              title: <FormattedMessage id="regular-claim-approval-reporting-manager" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/regular-approval-claim-reporting-manager',
              target: false,
              requestedMenu: regularApprovalClaimRMKey,
              requestedFeature: readKey
            },
            {
              id: 'regular-approval-claim-division-manager',
              title: <FormattedMessage id="regular-claim-approval-division-manager" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/regular-approval-claim-division-manager',
              target: false,
              requestedMenu: regularApprovalClaimDMKey,
              requestedFeature: readKey
            },
            {
              id: 'regular-approval-claim-hr',
              title: <FormattedMessage id="regular-claim-approval-hr" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/regular-approval-claim-hr',
              target: false,
              requestedMenu: regularApprovalClaimHRKey,
              requestedFeature: readKey
            },
            {
              id: 'regular-approval-claim-accounts-executive',
              title: <FormattedMessage id="regular-claim-approval-accounts-executive" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/regular-approval-claim-accounts-executive',
              target: false,
              requestedMenu: regularApprovalClaimAEKey,
              requestedFeature: readKey
            },
            {
              id: 'regular-approval-claim-accounts-manager',
              title: <FormattedMessage id="regular-claim-approval-accounts-manager" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/regular-approval-claim-accounts-manager',
              target: false,
              requestedMenu: regularApprovalClaimAMKey,
              requestedFeature: readKey
            },
            {
              id: 'common-notification',
              title: <FormattedMessage id="common-notification" />,
              type: 'item',
              icon: icons.RedEnvelopeFilled,
              url: '/common-notification',
              target: false,
              requestedMenu: commonNotificationKey,
              requestedFeature: readKey
            }
          ]
        }
      ]
      : []),
    ...(Reports.length >= 1
      ? [
        {
          id: 'reports',
          title: <FormattedMessage id="reports" />,
          type: 'collapse',
          // url: '/',
          icon: icons.FolderOpenFilled,
          allMenus: Reports,
          children: [
            {
              id: 'attendance-report',
              icon: icons.BarChartOutlined,
              title: <FormattedMessage id="attendance-report" />,
              type: 'item',
              url: '/attendance-report',
              target: false,
              requestedMenu: attendanceReportKey,
              requestedFeature: readKey
            },
            {
              id: 'app-track-report',
              icon: icons.RadarChartOutlined,
              title: <FormattedMessage id="app-track-report" />,
              type: 'item',
              url: '/app-track-report',
              target: false,
              requestedMenu: appTrackReportKey,
              requestedFeature: readKey
            },
            {
              id: 'competitor-report',
              title: <FormattedMessage id="competitor-report" />,
              type: 'item',
              icon: icons.GithubFilled,
              url: '/competitor-report',
              target: false,
              requestedMenu: competitorReportKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-details-report',
              title: <FormattedMessage id="claim-details-report" />,
              type: 'item',
              icon: icons.HeatMapOutlined,
              url: '/claim-details-report',
              target: false,
              requestedMenu: claimDetailsReportKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-expense-report',
              title: <FormattedMessage id="claim-expense-report" />,
              type: 'item',
              icon: icons.AreaChartOutlined,
              url: '/claim-expense-report',
              target: false,
              requestedMenu: claimExpenseReportKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-status-log',
              title: <FormattedMessage id="claim-status-log" />,
              type: 'item',
              icon: icons.FileImageOutlined,
              url: '/claim-status-log',
              target: false,
              requestedMenu: claimStatusLogKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-log',
              title: <FormattedMessage id="claim-log" />,
              type: 'item',
              icon: icons.FileImageOutlined,
              url: '/claim-log',
              target: false,
              requestedMenu: claimLogKey,
              requestedFeature: readKey
            },
            {
              id: 'claim-expense-log',
              title: <FormattedMessage id="claim-expense-log" />,
              type: 'item',
              icon: icons.FileImageOutlined,
              url: '/claim-expense-log',
              target: false,
              requestedMenu: claimExpenseLogKey,
              requestedFeature: readKey
            },
            {
              id: 'pjp-report',
              title: <FormattedMessage id="pjp-report" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/pjp-report',
              target: false,
              requestedMenu: pjpReportKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-details-report',
              title: <FormattedMessage id="plan-details-report" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/plan-details-report',
              target: false,
              requestedMenu: ifoodsPlanReportKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-report',
              title: <FormattedMessage id="plan-report" />,
              type: 'item',
              icon: icons.ContainerOutlined,
              url: '/plan-report',
              target: false,
              requestedMenu: ifoodsPlanReportKey,
              requestedFeature: readKey
            },
            {
              id: 'plan-deviation-report',
              title: <FormattedMessage id="plan-deviation-report" />,
              type: 'item',
              icon: icons.DatabaseOutlined,
              url: '/plan-deviation-report',
              target: false,
              requestedMenu: planDeviationReportKey,
              requestedFeature: readKey
            },
            {
              id: 'market-promotion-report',
              title: <FormattedMessage id="market-promotion-report" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/market-promotion-report',
              target: false,
              requestedMenu: marketPromotionReportKey,
              requestedFeature: readKey
            },
            {
              id: 'map-view',
              title: <FormattedMessage id="map-view" />,
              type: 'item',
              icon: icons.EnvironmentOutlined,
              url: '/map-view',
              target: false,
              requestedMenu: mapViewReportKey,
              requestedFeature: readKey
            },
            // {
            //   id: 'map',
            //   title: <FormattedMessage id="map" />,
            //   type: 'item',
            //   icon:icons.HomeFilled,
            //   url: '/map',
            //   target: false,
            //   requestedMenu: mapViewReportKey,
            //   requestedFeature: readKey
            // },
            {
              id: 'outlet-visit-report',
              title: <FormattedMessage id="outlet-visit-report" />,
              type: 'item',
              icon: icons.FileImageOutlined,
              url: '/outlet-visit-report',
              target: false,
              requestedMenu: outletVisitReportKey,
              requestedFeature: readKey
            },
            {
              id: 'primary-customer-report',
              title: <FormattedMessage id="primary-customer-report" />,
              type: 'item',
              icon: icons.ProfileFilled,
              url: '/primary-customer-report',
              target: false,
              requestedMenu: primeCustReportKey,
              requestedFeature: readKey
            },
            {
              id: 'primary-customer-visit-report',
              title: <FormattedMessage id="primary-customer-visit-report" />,
              type: 'item',
              icon: icons.FolderViewOutlined,
              url: '/primary-customer-visit-report',
              target: false,
              requestedMenu: primaryCustomerVisitReportKey,
              requestedFeature: readKey
            },
            {
              id: 'primary-order-report',
              title: <FormattedMessage id="primary-order-report" />,
              type: 'item',
              icon: icons.FundProjectionScreenOutlined,
              url: '/primary-order-report',
              target: false,
              requestedMenu: primaryOrderReportKey,
              requestedFeature: readKey
            },
            {
              id: 'secondary-customer-report',
              title: <FormattedMessage id="secondary-customer-report" />,
              type: 'item',
              icon: icons.IdcardOutlined,
              url: '/secondary-customer-report',
              target: false,
              requestedMenu: secondCustReportKey,
              requestedFeature: readKey
            },
            {
              id: 'secondary-outlet-visit-report',
              title: <FormattedMessage id="secondary-outlet-visit-report" />,
              type: 'item',
              icon: icons.LayoutOutlined,
              url: '/secondary-outlet-visit-report',
              target: false,
              requestedMenu: secondaryOutletVisitReportKey,
              requestedFeature: readKey
            },
            {
              id: 'secondary-order-report',
              title: <FormattedMessage id="secondary-order-report" />,
              type: 'item',
              icon: icons.HomeFilled,
              url: '/secondary-order-report',
              target: false,
              requestedMenu: secondaryOrderReportKey,
              requestedFeature: readKey
            },
            {
              id: 'prospect-report',
              title: <FormattedMessage id="prospect-report" />,
              type: 'item',
              icon: icons.DribbbleCircleFilled,
              url: '/prospect-report',
              target: false,
              requestedMenu: prospectReportKey,
              requestedFeature: readKey
            },
            {
              id: 'travel-claim-report',
              title: <FormattedMessage id="travel-claim-report" />,
              type: 'item',
              icon: icons.ProfileOutlined,
              url: '/travel-claim-report',
              target: false,
              requestedMenu: travelClaimReportKey,
              requestedFeature: readKey
            },
            {
              id: 'travel-report',
              title: <FormattedMessage id="travel-report" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/travel-report',
              target: false,
              requestedMenu: travelReportKey,
              requestedFeature: readKey
            },
            {
              id: 'user-report',
              icon: icons.BarChartOutlined,
              title: <FormattedMessage id="user-report" />,
              type: 'item',
              url: '/user-report',
              target: false,
              requestedMenu: userReportKey,
              requestedFeature: readKey
            },
            {
              id: 'venue-mapping-report',
              title: <FormattedMessage id="venue-mapping-report" />,
              type: 'item',
              icon: icons.CarFilled,
              url: '/venue-mapping-report',
              target: false,
              requestedMenu: venueMappingReportKey,
              requestedFeature: readKey
            }
          ]
        }
      ]
      : []),
    //==================================Sooji QR Bag==============================//
    ...(Production.length >= 1
      ? [
        {
          id: 'production',
          title: <FormattedMessage id="production" />,
          type: 'collapse',
          icon: icons.FolderOpenFilled,
          allMenus: Production, // Changed from Reports to Production
          children: [
            {
              id: 'new-bag-request',
              icon: icons.RadarChartOutlined,
              title: <FormattedMessage id="new-bag-request" />,
              type: 'item',
              url: '/new-bag-request',
              target: false,
              requestedMenu: newBagRequestKey,
              requestedFeature: readKey,
            },
            {
              id: 'bag-request',
              icon: icons.CodeSandboxSquareFilled,
              title: <FormattedMessage id="bag-request" />,
              type: 'item',
              url: '/bag-request',
              target: false,
              requestedMenu: bagRequestKey,
              requestedFeature: readKey,
            },
            {
              id: 'bag-issue',
              icon: icons.EditFilled,
              title: <FormattedMessage id="bag-issue" />,
              type: 'item',
              url: '/bag-issue',
              target: false,
              requestedMenu: bagIssueKey,
              requestedFeature: readKey,
            },
            {
              id: 'store-new-bag-request',
              icon: icons.CrownFilled,
              title: <FormattedMessage id="store-new-bag-request" />,
              type: 'item',
              url: '/store-new-bag-request',
              target: false,
              requestedMenu: storeNewBagRequestKey,
              requestedFeature: readKey,
            },
            {
              id: 'fill-bag',
              icon: icons.EnvironmentFilled,
              title: <FormattedMessage id="fill-bag" />,
              type: 'item',
              url: '/fill-bag',
              target: false,
              requestedMenu: fillBagKey,
              requestedFeature: readKey,
            },
            {
              id: 'qc-release',
              icon: icons.ScheduleOutlined,
              title: <FormattedMessage id="qc-release" />,
              type: 'item',
              url: '/qc-release',
              target: false,
              requestedMenu: qcReleaseKey,
              requestedFeature: readKey,
            },
            {
              id: 'quality-check-exceeded',
              icon: icons.ContainerOutlined,
              title: <FormattedMessage id="quality-check-exceeded" />,
              type: 'item',
              url: '/quality-check-exceeded',
              target: false,
              requestedMenu: qcReleaseExceededKey,
              requestedFeature: readKey,
            },
            {
              id: 'roasting-process',
              icon: icons.BankOutlined,
              title: <FormattedMessage id="roasting-process" />,
              type: 'item',
              url: '/roasting-process',
              target: false,
              requestedMenu: roastingProcessKey,
              requestedFeature: readKey,
            },
            {
              id: 'roasting-exceeded',
              icon: icons.ContainerOutlined,
              title: <FormattedMessage id="roasting-exceeded" />,
              type: 'item',
              url: '/roasting-exceeded',
              target: false,
              requestedMenu: roastingProcessExceededKey,
              requestedFeature: readKey,
            },
            {
              id: 'fumigation-process',
              icon: icons.DribbbleCircleFilled,
              title: <FormattedMessage id="fumigation-process" />,
              type: 'item',
              url: '/fumigation-process',
              target: false,
              requestedMenu: fumigationProcessKey,
              requestedFeature: readKey,
            },
            {
              id: 'fumigation-exceeded',
              icon: icons.ContainerOutlined,
              title: <FormattedMessage id="fumigation-exceeded" />,
              type: 'item',
              url: '/fumigation-exceeded',
              target: false,
              requestedMenu: fumigationProcessExceededKey,
              requestedFeature: readKey,
            },
            {
              id: 'bag-report',
              icon: icons.RedEnvelopeFilled,
              title: <FormattedMessage id="bag-report" />,
              type: 'item',
              url: '/bag-report',
              target: false,
              requestedMenu: bagReportKey,
              requestedFeature: readKey,
            },
            {
              id: 'qr-trans-report',
              icon: icons.LayoutOutlined,
              title: <FormattedMessage id="qr-trans-report" />,
              type: 'item',
              url: '/qr-trans-report',
              target: false,
              requestedMenu: qrTransReportKey,
              requestedFeature: readKey,
            },
            {
              id: 'qr-coded-bag-status-report',
              icon: icons.LayoutOutlined,
              title: <FormattedMessage id="qr-coded-bag-status-report" />,
              type: 'item',
              url: '/qr-coded-bag-status-report',
              target: false,
              requestedMenu: qrcodedBagStatusKey,
              requestedFeature: readKey,
            },
          ],
        },
      ]
      : []),
    /* ============== Scheme Dasboard Part Start ============== */
    ...(Scheme.length >= 1 ? [
      {
        id: 'scheme-dashboard',
        title: <FormattedMessage id="scheme-dashboard" />,
        type: 'collapse',
        icon: icons.BankOutlined,
        allMenus: Scheme,
        children: [
          {
            id: 'scheme-operations',
            title: <FormattedMessage id="scheme-operations" />,
            type: 'collapse',
            icon: icons.CarFilled,
            // url: '/ntruck-operations',
            target: false,
            requestedMenu: schemeOperationsKey,
            requestedFeature: readKey,
            children: [
              {
                id: 'scheme-creation',
                title: <FormattedMessage id="scheme-creation" />,
                type: 'item',
                icon: icons.RedEnvelopeFilled,
                url: '/scheme-creation',
                target: false,
                requestedMenu: schemeCreationKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-creation-approval',
                title: <FormattedMessage id="scheme-creation-approval" />,
                type: 'item',
                icon: icons.DribbbleCircleFilled,
                url: '/scheme-creation-approval',
                target: false,
                requestedMenu: schemeCreationApprovalKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-creation-approval-ch',
                title: <FormattedMessage id="scheme-creation-approval-ch" />,
                type: 'item',
                icon: icons.SwitcherFilled,
                url: '/scheme-creation-approval-ch',
                target: false,
                requestedMenu: schemeCreationApprovalCHKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-creation-approval-bh',
                title: <FormattedMessage id="scheme-creation-approval-bh" />,
                type: 'item',
                icon: icons.NodeCollapseOutlined,
                url: '/scheme-creation-approval-bh',
                target: false,
                requestedMenu: schemeCreationApprovalBHKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-status-master',
                title: <FormattedMessage id="scheme-status-master" />,
                type: 'item',
                icon: icons.EnvironmentOutlined,
                url: '/scheme-status-master',
                target: false,
                requestedMenu: schemeStatusMasterKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-cost-center-master',
                title: <FormattedMessage id="scheme-cost-center-master" />,
                type: 'item',
                icon: icons.DatabaseOutlined,
                url: '/scheme-cost-center-master',
                target: false,
                requestedMenu: schemeStatusMasterKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-product-cost-center-mapping',
                title: <FormattedMessage id="scheme-product-cost-center-mapping" />,
                type: 'item',
                icon: icons.SisternodeOutlined,
                url: '/scheme-product-cost-center-mapping',
                target: false,
                requestedMenu: schemeStatusMasterKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-non-eligible-approval',
                title: <FormattedMessage id="scheme-non-eligible-approval" />,
                type: 'item',
                icon: icons.CrownFilled,
                url: '/scheme-non-eligible-approval',
                target: false,
                requestedMenu: schemeNonEligibleApprovalMasterKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-gm-approval',
                title: <FormattedMessage id="scheme-gm-approval" />,
                type: 'item',
                icon: icons.RedEnvelopeFilled,
                url: '/scheme-gm-approval',
                target: false,
                requestedMenu: schemeGMApprovalKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-ch-approval',
                title: <FormattedMessage id="scheme-ch-approval" />,
                type: 'item',
                icon: icons.IdcardOutlined,
                url: '/scheme-ch-approval',
                target: false,
                requestedMenu: schemeCHapprovalKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-admin-edit',
                title: <FormattedMessage id="scheme-admin-edit" />,
                type: 'item',
                icon: icons.IdcardOutlined,
                url: '/scheme-admin-edit',
                target: false,
                requestedMenu: schemeAdminEditKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-bh-approval',
                title: <FormattedMessage id="scheme-bh-approval" />,
                type: 'item',
                icon: icons.LayoutOutlined,
                url: '/scheme-bh-approval',
                target: false,
                requestedMenu: schemeBHapprovalKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-ah-credit-note-approval',
                title: <FormattedMessage id="scheme-ah-credit-note-approval" />,
                type: 'item',
                icon: icons.HeatMapOutlined,
                url: '/scheme-ah-credit-note-approval',
                target: false,
                requestedMenu: schemeAHcreditnoteApprovalKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-credit-note-report',
                title: <FormattedMessage id="scheme-credit-note-report" />,
                type: 'item',
                icon: icons.CodeSandboxSquareFilled,
                url: '/scheme-credit-note-report',
                target: false,
                requestedMenu: schemeCreditnoteReportKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-customer-wise-report',
                title: <FormattedMessage id="Scheme Customer Wise Report" defaultMessage="Scheme Customer Wise Report" />,
                type: 'item',
                icon: icons.CodeSandboxSquareFilled,
                url: '/scheme-customer-wise-report',
                target: false,
                requestedMenu: schemeCustomerWiseReportKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-cost-center-actual-report',
                title: <FormattedMessage id="scheme-cost-center-actual-report" defaultMessage="Cost Center Actual Report" />,
                type: 'item',
                icon: icons.CodeSandboxSquareFilled,
                url: '/scheme-cost-center-actual-report',
                target: false,
                requestedMenu: schemeCostCenterActualReportKey,
                requestedFeature: readKey
              },
              {
                id: 'scheme-rejected-customer-report',
                title: <FormattedMessage id="scheme-rejected-customer-report" defaultMessage="Rejected Customer Report" />,
                type: 'item',
                icon: icons.CodeSandboxSquareFilled,
                url: '/scheme-rejected-customer-report',
                target: false,
                requestedMenu: schemeRejectedCustomerReportKey,
                requestedFeature: readKey
              },
            ]
          },
        ]
      },
    ] : []),
    /* ============== Scheme Dasboard Part Start ============== */
    ...(PestControl.length >= 1 ? [
      {
        id: 'pest-control',
        title: <FormattedMessage id="pest-control" defaultMessage="Pest Control" />,
        type: 'collapse',
        icon: icons.RobotFilled,
        allMenus: PestControl,
        children: [
          {
            id: 'pest-control-daily-entry',
            title: <FormattedMessage id="daily-entry" defaultMessage="Daily Entry" />,
            type: 'item',
            icon: icons.EditFilled,
            url: '/pest-control/daily-entry',
            target: false,
            requestedMenu: pestControlDailyEntryKey,
            requestedFeature: readKey
          },
          {
            id: 'pest-control-report',
            title: <FormattedMessage id="pest-control-report" defaultMessage="Pest Control Report" />,
            type: 'item',
            icon: icons.ReconciliationFilled,
            url: '/pest-control/report',
            target: false,
            requestedMenu: pestControlReportKey,
            requestedFeature: readKey
          },
          {
            id: 'pest-control-rodent-box-location',
            title: <FormattedMessage id="rodent-box-location-master" defaultMessage="Rodent Box Location Master" />,
            type: 'item',
            icon: icons.EnvironmentFilled,
            url: '/pest-control/rodent-box-location',
            target: false,
            requestedMenu: rodentBoxLocationMasterKey,
            requestedFeature: readKey
          },
          {
            id: 'pest-control-location-trap-station-mapping',
            title: <FormattedMessage id="location-trap-station-mapping" defaultMessage="Location Trap Station Mapping" />,
            type: 'item',
            icon: icons.SwitcherFilled,
            url: '/pest-control/location-trap-station-mapping',
            target: false,
            requestedMenu: locationTrapStationMappingKey,
            requestedFeature: readKey
          },
          {
            id: 'pest-control-rodent-qr-code',
            title: <FormattedMessage id="rodent-qr-code-master" defaultMessage="Rodent QR Code" />,
            type: 'item',
            icon: icons.QrcodeOutlined,
            url: '/pest-control/rodent-qr-code',
            target: false,
            requestedMenu: rodentQRCodeKey,
            requestedFeature: readKey
          },
          {
            id: 'pest-control-rodent-qr-code-mapping',
            title: <FormattedMessage id="rodent-qr-code-mapping" defaultMessage="Rodent QR Code Mapping" />,
            type: 'item',
            icon: icons.CodeSandboxSquareFilled,
            url: '/pest-control/rodent-qr-code-mapping',
            target: false,
            requestedMenu: rodentQRCodeMappingKey,
            requestedFeature: readKey
          }
        ]
      }
    ] : [])
  ]
};

export default pages;
